"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3851],{

/***/ 48748:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _material_ui_core_Button__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(282);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(186);




function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background-color: #d4323b;\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  position: absolute;\n  top: ",
        ";\n  right: ",
        ";\n  color: #fff;\n  font-size: ",
        ";\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background-color: #d4323b;\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  position: absolute;\n  top: 11%;\n  right: 5%;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  &.MuiButtonBase-root {\n    min-width: 48px;\n  }\n  &.Mui-disabled {\n    opacity: 0.7;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}




var CustomQuantity = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-a3d6d602-0"
})(_templateObject(), function(props) {
    return props.isProductPage ? "-11%" : "5%";
}, function(props) {
    return props.isProductPage ? "0%" : "5%";
}, function(props) {
    return props.quantity >= props.max ? "10px" : "12px";
});
var Dots = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-a3d6d602-1"
})(_templateObject1());
var MobileBadge = function(props) {
    var children = props.children, className = props.className, _quantity = props.quantity, quantity = _quantity === void 0 ? 0 : _quantity, _isAvartar = props.isAvartar, isAvartar = _isAvartar === void 0 ? false : _isAvartar, handleOnClick = props.handleOnClick, _isDot = props.isDot, isDot = _isDot === void 0 ? false : _isDot, _optSort = props.optSort, optSort = _optSort === void 0 ? "" : _optSort, _isProductPage = props.isProductPage, isProductPage = _isProductPage === void 0 ? false : _isProductPage, restProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(props, [
        "children",
        "className",
        "quantity",
        "isAvartar",
        "handleOnClick",
        "isDot",
        "optSort",
        "isProductPage"
    ]);
    var max = 100;
    if (isAvartar) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_core_Button__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
            className: className,
            onClick: handleOnClick
        }, restProps), {
            children: children
        }));
    }
    if (isDot) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_material_ui_core_Button__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
            className: className,
            onClick: handleOnClick
        }, restProps), {
            children: [
                children,
                optSort && optSort !== "" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Dots, {})
            ]
        }));
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_material_ui_core_Button__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
        className: className,
        onClick: handleOnClick
    }, restProps), {
        children: [
            children,
            quantity > 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(CustomQuantity, {
                quantity: quantity,
                max: max,
                isProductPage: isProductPage,
                children: quantity >= max ? "99+" : quantity
            }) : ""
        ]
    }));
};
var StyledBadge = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(MobileBadge).withConfig({
    componentId: "sc-a3d6d602-2"
})(_templateObject2());
/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.memo(StyledBadge));


/***/ }),

/***/ 76726:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B6": function() { return /* binding */ ICON_MOBILE_ICON_SLIDE_ARROW_RIGHT; },
/* harmony export */   "C1": function() { return /* binding */ ICON_MOBILE_ICON_EMPTY_CHAT; },
/* harmony export */   "Fl": function() { return /* binding */ ICON_MOBILE_ICON_DEAL; },
/* harmony export */   "I9": function() { return /* binding */ ICON_MOBILE_ICON_SENDING; },
/* harmony export */   "OJ": function() { return /* binding */ ICON_MOBILE_AVATAR_CS; },
/* harmony export */   "Op": function() { return /* binding */ ICON_MOBILE_ICON_SENT; },
/* harmony export */   "VA": function() { return /* binding */ ICON_MOBILE_ICON_FOR_YOU; },
/* harmony export */   "ZP": function() { return /* binding */ SEARCH_ICON; },
/* harmony export */   "bO": function() { return /* binding */ ICON_MOBILE_ICON_BACK; },
/* harmony export */   "cE": function() { return /* binding */ ICON_MOBILE_ICON_HOME; },
/* harmony export */   "dJ": function() { return /* binding */ ICON_MOBILE_ICON_SLIDE_ARROW_LEFT; },
/* harmony export */   "dl": function() { return /* binding */ ICON_MOBILE_ICON_DISCOVERY; },
/* harmony export */   "fj": function() { return /* binding */ ICON_MOBILE_ICON_DOUBLE_ARROW_RIGHT; },
/* harmony export */   "ge": function() { return /* binding */ MOBILE_LOGO; },
/* harmony export */   "if": function() { return /* binding */ ICON_MOBILE_ICON_SEARCH; },
/* harmony export */   "k6": function() { return /* binding */ ICON_MOBILE_ICON_QUICK_ORDER; },
/* harmony export */   "xu": function() { return /* binding */ ICON_MOBILE_ICON_SEARCH_WHITE; }
/* harmony export */ });
/* unused harmony exports ICON_MOBILE_ICON_CART, ICON_MOBILE_ICON_STORE, ICON_MOBILE_ICON_COUPON, ICON_MOBILE_ICON_PRODUCT, ICON_MOBILE_ICON_RANK_DIAMOND, ICON_MOBILE_ICON_RANK_GOLD, ICON_MOBILE_ICON_RANK_PLATIUM, ICON_MOBILE_ICON_RANK_SILVER, ICON_MOBILE_ICON_TS_POINT, ICON_MOBILE_ICON_WALLET, ICON_MOBILE_BUSINESS_ICON, ICON_MOBILE_ICON_SORT, ICON_MOBILE_ICON_FILTER, ICON_MOBILE_ICON_ALERT_WARNING, ICON_MOBILE_ICON_ALERT_SUCCESS, ICON_MOBILE_ICON_CHAT */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var constants_Images_mobile__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(93893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var utils_ImageFallback__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(34588);



// TODO: refactor contanst


var SEARCH_ICON = "/icons/mobile/search_icon.svg";
var MOBILE_LOGO = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.memo)(function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utils_ImageFallback__WEBPACK_IMPORTED_MODULE_3__/* .ImageFallbackStatic */ .ez, {
        src: constants_Images_mobile__WEBPACK_IMPORTED_MODULE_4__/* .ICON_MOBILE_LOGO */ .oO,
        width: 50,
        height: 50,
        priority: true
    });
});
var ICON_MOBILE_ICON_CART = /*#__PURE__*/ (/* unused pure expression or super */ null && (memo(function() {
    return /*#__PURE__*/ _jsx(ImageFallbackStatic, {
        src: MOBILE_ICON_CART,
        width: 50,
        height: 50,
        priority: true
    });
})));
var ICON_MOBILE_ICON_DISCOVERY = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.memo)(function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utils_ImageFallback__WEBPACK_IMPORTED_MODULE_3__/* .ImageFallbackStatic */ .ez, {
        src: constants_Images_mobile__WEBPACK_IMPORTED_MODULE_4__/* .MOBILE_ICON_DISCOVERY */ .U3,
        width: 24,
        height: 24,
        priority: true
    });
});
var ICON_MOBILE_ICON_STORE = /*#__PURE__*/ (/* unused pure expression or super */ null && (memo(function() {
    return /*#__PURE__*/ _jsx(ImageFallbackStatic, {
        src: MOBILE_ICON_STORE,
        width: 24,
        height: 24,
        priority: true
    });
})));
var ICON_MOBILE_ICON_HOME = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.memo)(function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utils_ImageFallback__WEBPACK_IMPORTED_MODULE_3__/* .ImageFallbackStatic */ .ez, {
        src: constants_Images_mobile__WEBPACK_IMPORTED_MODULE_4__/* .MOBILE_ICON_HOME */ .EC,
        width: 24,
        height: 24,
        priority: true
    });
});
var ICON_MOBILE_ICON_COUPON = /*#__PURE__*/ (/* unused pure expression or super */ null && (memo(function() {
    return /*#__PURE__*/ _jsx(ImageFallbackStatic, {
        src: MOBILE_ICON_COUPON,
        width: 24,
        height: 24,
        priority: true
    });
})));
var ICON_MOBILE_ICON_PRODUCT = /*#__PURE__*/ (/* unused pure expression or super */ null && (memo(function() {
    return /*#__PURE__*/ _jsx(ImageFallbackStatic, {
        src: MOBILE_ICON_PRODUCT,
        width: 24,
        height: 24,
        priority: true
    });
})));
var ICON_MOBILE_ICON_DEAL = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.memo)(function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utils_ImageFallback__WEBPACK_IMPORTED_MODULE_3__/* .ImageFallbackStatic */ .ez, {
        src: constants_Images_mobile__WEBPACK_IMPORTED_MODULE_4__/* .MOBILE_ICON_DEAL */ .Mn,
        width: 24,
        height: 24,
        priority: true
    });
});
var ICON_MOBILE_ICON_QUICK_ORDER = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.memo)(function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utils_ImageFallback__WEBPACK_IMPORTED_MODULE_3__/* .ImageFallbackStatic */ .ez, {
        src: constants_Images_mobile__WEBPACK_IMPORTED_MODULE_4__/* .MOBILE_ICON_QUICK_ORDER */ .m3,
        width: 50,
        height: 50,
        priority: true
    });
});
var ICON_MOBILE_ICON_FOR_YOU = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.memo)(function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utils_ImageFallback__WEBPACK_IMPORTED_MODULE_3__/* .ImageFallbackStatic */ .ez, {
        src: constants_Images_mobile__WEBPACK_IMPORTED_MODULE_4__/* .MOBILE_ICON_FOR_YOU */ .IL,
        width: 24,
        height: 24,
        priority: true
    });
});
var ICON_MOBILE_ICON_BACK = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.memo)(function(param) {
    var _width = param.width, width = _width === void 0 ? 24 : _width, _height = param.height, height = _height === void 0 ? 24 : _height;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utils_ImageFallback__WEBPACK_IMPORTED_MODULE_3__/* .ImageFallbackStatic */ .ez, {
        src: constants_Images_mobile__WEBPACK_IMPORTED_MODULE_4__/* .MOBILE_ICON_BACK */ .Kh,
        width: width,
        height: height,
        priority: true
    });
});
var ICON_MOBILE_ICON_SEARCH = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.memo)(function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utils_ImageFallback__WEBPACK_IMPORTED_MODULE_3__/* .ImageFallbackStatic */ .ez, {
        src: constants_Images_mobile__WEBPACK_IMPORTED_MODULE_4__/* .MOBILE_ICON_SEARCH */ .UI,
        width: 24,
        height: 24,
        priority: true
    });
});
var ICON_MOBILE_ICON_RANK_DIAMOND = /*#__PURE__*/ (/* unused pure expression or super */ null && (memo(function() {
    return /*#__PURE__*/ _jsx(ImageFallbackStatic, {
        src: MOBILE_ICON_RANK_DIAMOND,
        width: 24,
        height: 24,
        priority: true
    });
})));
var ICON_MOBILE_ICON_RANK_GOLD = /*#__PURE__*/ (/* unused pure expression or super */ null && (memo(function() {
    return /*#__PURE__*/ _jsx(ImageFallbackStatic, {
        src: MOBILE_ICON_RANK_GOLD,
        width: 24,
        height: 24,
        priority: true
    });
})));
var ICON_MOBILE_ICON_RANK_PLATIUM = /*#__PURE__*/ (/* unused pure expression or super */ null && (memo(function() {
    return /*#__PURE__*/ _jsx(ImageFallbackStatic, {
        src: MOBILE_ICON_RANK_PLATIUM,
        width: 24,
        height: 24,
        priority: true
    });
})));
var ICON_MOBILE_ICON_RANK_SILVER = /*#__PURE__*/ (/* unused pure expression or super */ null && (memo(function() {
    return /*#__PURE__*/ _jsx(ImageFallbackStatic, {
        src: MOBILE_ICON_RANK_SILVER,
        width: 24,
        height: 24,
        priority: true
    });
})));
var ICON_MOBILE_ICON_TS_POINT = /*#__PURE__*/ (/* unused pure expression or super */ null && (memo(function() {
    return /*#__PURE__*/ _jsx(ImageFallbackStatic, {
        src: MOBILE_ICON_TS_POINT,
        width: 24,
        height: 24,
        priority: true
    });
})));
var ICON_MOBILE_ICON_WALLET = /*#__PURE__*/ (/* unused pure expression or super */ null && (memo(function() {
    return /*#__PURE__*/ _jsx(ImageFallbackStatic, {
        src: MOBILE_ICON_WALLET,
        width: 24,
        height: 24,
        priority: true
    });
})));
var ICON_MOBILE_BUSINESS_ICON = /*#__PURE__*/ (/* unused pure expression or super */ null && (memo(function() {
    return /*#__PURE__*/ _jsx(ImageFallbackStatic, {
        src: BUSINESS_ICON,
        width: 24,
        height: 24,
        priority: true
    });
})));
var ICON_MOBILE_ICON_SEARCH_WHITE = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.memo)(function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utils_ImageFallback__WEBPACK_IMPORTED_MODULE_3__/* .ImageFallbackStatic */ .ez, {
        src: constants_Images_mobile__WEBPACK_IMPORTED_MODULE_4__/* .MOBILE_ICON_SEARCH_WHITE */ .Bh,
        width: 24,
        height: 24,
        priority: true
    });
});
var ICON_MOBILE_ICON_SORT = /*#__PURE__*/ (/* unused pure expression or super */ null && (memo(function() {
    return /*#__PURE__*/ _jsx(ImageFallbackStatic, {
        src: MOBILE_ICON_SORT,
        width: 24,
        height: 24,
        priority: true
    });
})));
var ICON_MOBILE_ICON_FILTER = /*#__PURE__*/ (/* unused pure expression or super */ null && (memo(function() {
    return /*#__PURE__*/ _jsx(ImageFallbackStatic, {
        src: MOBILE_ICON_FILTER,
        width: 24,
        height: 24,
        priority: true
    });
})));
var ICON_MOBILE_ICON_ALERT_WARNING = /*#__PURE__*/ (/* unused pure expression or super */ null && (memo(function() {
    return /*#__PURE__*/ _jsx(ImageFallbackStatic, {
        src: MOBILE_ICON_ALERT_WARNING,
        width: 24,
        height: 24,
        priority: true
    });
})));
var ICON_MOBILE_ICON_ALERT_SUCCESS = /*#__PURE__*/ (/* unused pure expression or super */ null && (memo(function() {
    return /*#__PURE__*/ _jsx(ImageFallbackStatic, {
        src: MOBILE_ICON_ALERT_SUCCESS,
        width: 24,
        height: 24,
        priority: true
    });
})));
var ICON_MOBILE_ICON_DOUBLE_ARROW_RIGHT = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.memo)(function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utils_ImageFallback__WEBPACK_IMPORTED_MODULE_3__/* .ImageFallbackStatic */ .ez, {
        src: constants_Images_mobile__WEBPACK_IMPORTED_MODULE_4__/* .MOBILE_DOUBLE_ARROW_RIGHT */ .BL,
        width: 12,
        height: 9,
        priority: true
    });
});
var ICON_MOBILE_ICON_SLIDE_ARROW_RIGHT = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.memo)(function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utils_ImageFallback__WEBPACK_IMPORTED_MODULE_3__/* .ImageFallbackStatic */ .ez, {
        src: constants_Images_mobile__WEBPACK_IMPORTED_MODULE_4__/* .MOBILE_ICON_SLIDE_ARROW_RIGHT */ .T7,
        width: 12,
        height: 12,
        priority: true
    });
});
var ICON_MOBILE_ICON_SLIDE_ARROW_LEFT = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.memo)(function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utils_ImageFallback__WEBPACK_IMPORTED_MODULE_3__/* .ImageFallbackStatic */ .ez, {
        src: constants_Images_mobile__WEBPACK_IMPORTED_MODULE_4__/* .MOBILE_ICON_SLIDE_ARROW_LEFT */ .eN,
        width: 12,
        height: 12,
        priority: true
    });
});
var ICON_MOBILE_AVATAR_CS = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.memo)(function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
        src: constants_Images_mobile__WEBPACK_IMPORTED_MODULE_4__/* .MOBILE_ICON_AVATAR_CS */ .U0,
        width: 40,
        height: 40,
        priority: true
    });
});
var ICON_MOBILE_ICON_CHAT = /*#__PURE__*/ (/* unused pure expression or super */ null && (memo(function() {
    return /*#__PURE__*/ _jsx(Image, {
        src: MOBILE_ICON_CHAT,
        width: 44,
        height: 44,
        priority: true
    });
})));
var ICON_MOBILE_ICON_EMPTY_CHAT = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.memo)(function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
        src: constants_Images_mobile__WEBPACK_IMPORTED_MODULE_4__/* .MOBILE_ICON_EMPTY_CHAT */ .B9,
        width: 250,
        height: 183,
        priority: true
    });
});
var ICON_MOBILE_ICON_SENT = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.memo)(function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
        src: constants_Images_mobile__WEBPACK_IMPORTED_MODULE_4__/* .MOBILE_ICON_SENT */ .ft,
        width: 13,
        height: 13,
        priority: true
    });
});
var ICON_MOBILE_ICON_SENDING = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.memo)(function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
        src: constants_Images_mobile__WEBPACK_IMPORTED_MODULE_4__/* .MOBILE_ICON_SENDING */ .Qg,
        width: 13,
        height: 13,
        priority: true
    });
});


/***/ }),

/***/ 76412:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Fi": function() { return /* binding */ TagCode; },
/* harmony export */   "_A": function() { return /* binding */ MENUS_UTIL; },
/* harmony export */   "dU": function() { return /* binding */ MENUS_USER_INFO; },
/* harmony export */   "ek": function() { return /* binding */ ENUM_PRODUCT_TYPE; },
/* harmony export */   "jj": function() { return /* binding */ ENUM_SELLER_TYPE; },
/* harmony export */   "oG": function() { return /* binding */ tagList; },
/* harmony export */   "ob": function() { return /* binding */ MENUS_SUPPORT; },
/* harmony export */   "tV": function() { return /* binding */ BRAND_NAME_SHORT; },
/* harmony export */   "wf": function() { return /* binding */ ACCOUNTS_TRIAL; },
/* harmony export */   "z8": function() { return /* binding */ LINK_DIRECT_TO_TELE; }
/* harmony export */ });
/* unused harmony exports HOME_MENUS, BRAND_NAME, BRAND_NAME_LONG, ADDRESS_BUSSINESS, PHONE_NUMBER_STR, PHONE_NUMBER, LINK_DIRECT_TO_MESSENGER */
/* harmony import */ var constants_Images_mobile__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93893);
/* harmony import */ var constants_Paths__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(199);


var HOME_MENUS = [
    {
        name: "menu.products",
        url: constants_Paths__WEBPACK_IMPORTED_MODULE_0__/* .PRODUCTS_URL */ .NL,
        icon: constants_Images_mobile__WEBPACK_IMPORTED_MODULE_1__/* .PRODUCT_ICON */ .dU,
        id: 1
    },
    {
        name: "menu.ingredients",
        url: constants_Paths__WEBPACK_IMPORTED_MODULE_0__/* .INGREDIENT */ .gL,
        icon: constants_Images_mobile__WEBPACK_IMPORTED_MODULE_1__/* .INGREDIENT_ICON */ .HO,
        id: 2
    },
    {
        name: "menu.promotion",
        url: constants_Paths__WEBPACK_IMPORTED_MODULE_0__/* .PROMO_CODES */ .Q2,
        icon: constants_Images_mobile__WEBPACK_IMPORTED_MODULE_1__/* .COUPON_ICON */ .PL,
        id: 3
    }, 
];
var BRAND_NAME_SHORT = "BuyMed";
var BRAND_NAME = "Buymed Siam";
var BRAND_NAME_LONG = "Buymed Siam";
var ADDRESS_BUSSINESS = "98/28 Moo.1, Bang Sao Thong, Bang Sao Thong, Samut Prakan, Thailand 10570.";
var PHONE_NUMBER_STR = "02-483-0933";
var PHONE_NUMBER = "+6624830933";
var LINK_DIRECT_TO_MESSENGER = "https://m.me/thuocsivn";
// export const LINK_DIRECT_TO_TELE = `https://telegram.me/${PHONE_NUMBER}`;
var LINK_DIRECT_TO_TELE = "https://line.me/R/ti/p/@616fszhu";
var MENUS_USER_INFO = [
    {
        name: "personal_info",
        href: "/my-account",
        srcIcon: constants_Images_mobile__WEBPACK_IMPORTED_MODULE_1__/* .MOBILE_USER_ICON */ .qe
    },
    // {
    //   name: 'Thông tin cấp bậc',
    //   href: '',
    //   srcIcon: LEVEL_ICON,
    // },
    {
        name: "business_info",
        href: "/user/business-information",
        srcIcon: constants_Images_mobile__WEBPACK_IMPORTED_MODULE_1__/* .BUSINESS_ICON */ .zG
    }, 
];
var MENUS_UTIL = [
    {
        name: "my_orders",
        href: "/my-order",
        srcIcon: constants_Images_mobile__WEBPACK_IMPORTED_MODULE_1__/* .ORDER_ICON */ .Ln
    },
    {
        name: "bill_of_lading_lookup",
        href: "/tracking-order",
        srcIcon: constants_Images_mobile__WEBPACK_IMPORTED_MODULE_1__/* .TRUCK_ICON */ .rx
    },
    // {
    //   name: 'Thông tin xuất hóa đơn',
    //   href: '/productviewed',
    //   srcIcon: DOCUMENT_ICON2,
    // },
    {
        name: "order_statistics",
        href: "/user/dashboard",
        srcIcon: constants_Images_mobile__WEBPACK_IMPORTED_MODULE_1__/* .INSIGHT_ICON */ .hr
    },
    {
        name: "viewed_products",
        href: "/productviewed",
        srcIcon: constants_Images_mobile__WEBPACK_IMPORTED_MODULE_1__/* .M_EYE_ICON */ .C6
    },
    {
        name: "refer_friends",
        href: "/users/referrals",
        srcIcon: constants_Images_mobile__WEBPACK_IMPORTED_MODULE_1__/* .INFO_ICON */ .lS
    },
    {
        name: "my_discount",
        href: constants_Paths__WEBPACK_IMPORTED_MODULE_0__/* .USER_PROMO_CODES_URL */ .Py,
        srcIcon: constants_Images_mobile__WEBPACK_IMPORTED_MODULE_1__/* .MOBILE_VOUCHER_ICON */ .He
    },
    {
        name: "interested_products",
        href: "/user/wishlist",
        srcIcon: constants_Images_mobile__WEBPACK_IMPORTED_MODULE_1__/* .HEART_ICON */ .Un
    },
    {
        name: "look_up_product",
        href: "/qr",
        srcIcon: constants_Images_mobile__WEBPACK_IMPORTED_MODULE_1__/* .RESEARCH_INFO_ICON */ .x7
    },
    {
        name: "my_feedback",
        href: "/users/my-ticket",
        srcIcon: constants_Images_mobile__WEBPACK_IMPORTED_MODULE_1__/* .CHAT_ICON */ .cK
    },
    {
        name: "reward_points",
        href: "/users/loyalty_points",
        srcIcon: constants_Images_mobile__WEBPACK_IMPORTED_MODULE_1__/* .POINT_ACCUMULATING_ICON */ .bv
    },
    {
        name: "reward_events",
        href: "/users/rewards",
        srcIcon: constants_Images_mobile__WEBPACK_IMPORTED_MODULE_1__/* .HAND_SHAKE_ICON */ .wp
    }, 
];
var MENUS_SUPPORT = [
    {
        name: "common_questions",
        href: "https://thuocsihotro.helpwise.help/",
        srcIcon: constants_Images_mobile__WEBPACK_IMPORTED_MODULE_1__/* .QUESTION_ICON */ .RD
    },
    {
        name: "hotline",
        href: "tel:+842873008840",
        srcIcon: constants_Images_mobile__WEBPACK_IMPORTED_MODULE_1__/* .PHONE_ICON */ .EU
    },
    {
        name: "hotline_tele",
        href: "tel:+02-483-0933",
        srcIcon: constants_Images_mobile__WEBPACK_IMPORTED_MODULE_1__/* .PHONE_ICON */ .EU
    },
    {
        name: "chat_contact",
        href: LINK_DIRECT_TO_MESSENGER,
        srcIcon: constants_Images_mobile__WEBPACK_IMPORTED_MODULE_1__/* .CONTACT_ICON */ .KX
    },
    {
        name: "chat_contact_tele",
        href: LINK_DIRECT_TO_TELE,
        srcIcon: constants_Images_mobile__WEBPACK_IMPORTED_MODULE_1__/* .CONTACT_ICON */ .KX
    }, 
];
var ENUM_PRODUCT_TYPE = {
    KHUYENMAI: "khuyenmai",
    NEW: "new",
    FAV: "fav"
};
var ENUM_SELLER_TYPE = {
    ALL: "all",
    FLAGSHIP: "flagship"
};
var ACCOUNTS_TRIAL = {
    prd: [
        16236,
        59954,
        31217,
        46433,
        24079,
        40543,
        31680,
        33223,
        606,
        63761,
        82295,
        29412,
        3556,
        74843,
        74326,
        14183,
        42320,
        68705,
        51644,
        13344,
        726,
        91787,
        56644,
        52904,
        43409,
        40132,
        22272,
        81345,
        76029,
        46913,
        54056,
        8244,
        3013,
        37592,
        221073,
        79549,
        227444,
        91661,
        62743,
        218228,
        89357,
        244185,
        48845,
        253562,
        73230,
        74027,
        45079,
        4968,
        89768,
        92729,
        234491,
        249365,
        89377,
        55990,
        38097,
        94401,
        225343,
        91230,
        94843,
        82919,
        81372,
        253699,
        226652,
        237691,
        248883,
        227714,
        92730,
        11856,
        244703,
        205792,
        253556,
        60803,
        218616,
        82835,
        226001,
        79342,
        36289,
        68951,
        218511,
        73802,
        11244,
        28393,
        68476,
        270946,
        245254,
        34936,
        31539,
        88356,
        233664,
        226273,
        91487,
        222566,
        82221,
        238730,
        225688,
        235299,
        53784,
        222654,
        46359,
        267038,
        69353,
        80958,
        227446,
        251412,
        230234,
        255311,
        29976,
        47701,
        230086,
        52621,
        31835,
        83101,
        56124,
        223662,
        90539,
        71992,
        248895,
        245519,
        61808,
        253238,
        48727,
        64801,
        91247,
        242995,
        254007,
        224139,
        205065,
        90169,
        206435,
        61136,
        39267,
        91029,
        43805,
        242804,
        64655,
        248894,
        73573,
        62199,
        92335,
        74466,
        37820,
        244195,
        23096,
        25678,
        217377,
        236150,
        77357,
        32791,
        266958,
        243821,
        16236,
        59954,
        31217,
        46433,
        24079,
        40543,
        31680,
        33223,
        606,
        63761,
        82295,
        29412,
        3556,
        74843,
        74326,
        14183,
        42320,
        68705,
        51644,
        13344,
        726,
        91787,
        56644,
        52904,
        43409,
        40132,
        22272,
        81345,
        76029,
        46913,
        54056,
        8244,
        3013,
        37592,
        221073,
        79549,
        227444,
        91661,
        62743,
        218228,
        89357,
        244185,
        48845,
        253562,
        73230,
        74027,
        45079,
        4968,
        89768,
        92729,
        234491,
        249365,
        89377,
        55990,
        38097,
        94401,
        225343,
        91230,
        94843,
        82919,
        81372,
        253699,
        226652,
        237691,
        248883,
        227714,
        92730,
        11856,
        244703,
        205792,
        253556,
        60803,
        218616,
        82835,
        226001,
        79342,
        36289,
        68951,
        218511,
        73802,
        11244,
        28393,
        68476,
        270946,
        245254,
        34936,
        31539,
        88356,
        233664,
        226273,
        91487,
        222566,
        82221,
        238730,
        225688,
        235299,
        53784,
        222654,
        46359,
        267038,
        69353,
        80958,
        227446,
        251412,
        230234,
        255311,
        29976,
        47701,
        230086,
        52621,
        31835,
        83101,
        56124,
        223662,
        90539,
        71992,
        248895,
        245519,
        61808,
        253238,
        48727,
        64801,
        91247,
        242995,
        254007,
        224139,
        205065,
        90169,
        206435,
        61136,
        39267,
        91029,
        43805,
        242804,
        64655,
        248894,
        73573,
        62199,
        92335,
        74466,
        37820,
        244195,
        23096,
        25678,
        217377,
        236150,
        77357,
        32791,
        266958,
        243821,
        247359,
        247884,
        254737,
        260042,
        247657, 
    ],
    stg: [
        2511,
        2871,
        2730
    ]
};
var TagCode = {
    SP: "@SP_",
    DH: "@DH_",
    HOTRO: "@HOTRO_"
};
var tagList = [
    {
        code: TagCode.SP,
        image: "/icons/mobile/chat/SP.svg",
        title: "Tag sản phẩm",
        titleCode: "product_tag",
        guide: "".concat(TagCode.SP)
    },
    {
        code: TagCode.DH,
        image: "/icons/mobile/chat/DH.svg",
        title: "Tag đơn h\xe0ng",
        titleCode: "order_tag",
        guide: "".concat(TagCode.DH)
    },
    {
        code: TagCode.HOTRO,
        image: "/icons/mobile/chat/HOTRO.svg",
        title: "Tag phiếu hỗ trợ",
        titleCode: "support_ticket_tag",
        guide: "".concat(TagCode.HOTRO)
    }, 
];
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ({});


/***/ })

}]);